import { NaturalPersonDto } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { NaturalPersonFormFieldNames } from 'features/new-actor/enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { LegalEntityContactFormValues } from 'features/new-actor/types/legalEntityContactFormValues';
import { toDayInput } from 'core/utils/dates';
import { normalizeCountryCode } from './normalizeCountryCode';

export function mapLegalEntityContact(
  values: NaturalPersonDto,
  referentialsData: any
): LegalEntityContactFormValues {

  const getCountryCode = (id?: string | null) => {
    const country = referentialsData[ReferentialKey.Country].find((item: any) => item.id === id);
    return country ? (country.code as string) : undefined;
  };

  const getNationnalityCode = (id?: string | null) => {
    const data = referentialsData[ReferentialKey.Nationality].find((item: any) => item.id === id);
    return data ? (data.code as string) : undefined;
  };

  const getCivilityCode = (id: string) => {
    const data = referentialsData[ReferentialKey.Civility].find((item: any) => item.id === id);
    return data ? (data.code as string) : undefined;
  };

  const findReferentialCode = (referentialType: ReferentialKey, id?: string | null): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.id === id);
    return item?.code || '';
  };

  const {
    id,
    civilityId,
    nationalityId,
    birthDate,
    firstName,
    lastName,
    phone,
    address,
    birthName,
    birthCountryId,
    email,
    taxResidenceCountryId,
    isPPE,
    isFPE,
    companyRole
  } = values;

  return {
    id,
    [PersonalInformationFieldNames.Civility]: getCivilityCode(civilityId) || '',
    [PersonalInformationFieldNames.FirstName]: firstName,
    [PersonalInformationFieldNames.LastName]: lastName,
    [PersonalInformationFieldNames.BirthName]: birthName,
    // Date calendaire : découpe de string, jamais Date -> toISOString (décale d'un jour)
    [PersonalInformationFieldNames.BirthDate]: toDayInput(birthDate),
    [PersonalInformationFieldNames.Nationality]: getNationnalityCode(nationalityId) || '',
    [PersonalInformationFieldNames.BirthCountry]: getCountryCode(birthCountryId) || '',
    [PersonalInformationFieldNames.Phone]: phone,
    [PersonalInformationFieldNames.Email]: email,
    [AddressFormFieldNames.Address]: address?.line1 ?? '',
    [AddressFormFieldNames.City]: address?.city ?? '',
    [AddressFormFieldNames.AdditionalAddress]: address?.line2 || address?.line3 || undefined,
    [AddressFormFieldNames.PostalCode]: address?.zipCode ?? '',
    [AddressFormFieldNames.Country]: normalizeCountryCode(address?.country, referentialsData),
    // place_id / coordonnées doivent être rechargés pour ne pas invalider l'adresse en édition.
    [AddressFormFieldNames.GooglePlaceId]: address?.googlePlaceId ?? undefined,
    [AddressFormFieldNames.Latitude]: address?.latitude,
    [AddressFormFieldNames.Longitude]: address?.longitude,
    [NaturalPersonFormFieldNames.TaxResidenceCountryId]: getCountryCode(taxResidenceCountryId) || '',
    [PersonalInformationFieldNames.IsPPE]: isPPE,
    [PersonalInformationFieldNames.IsFPE]: isFPE || false,
    [LegalEntityFormFieldNames.CompanyRole]: findReferentialCode(ReferentialKey.CompanyRole, companyRole)
  };
}
